// src/com/help/HelpButton.js
import { useReactiveVar } from "@apollo/client";
import { currentMenuRepo, helpTopicRepo } from "../../model/CvoModel";
import InfoIcon from '@mui/icons-material/Info';
import { AppWord } from "../../model/AppConst";
import { HelpCustInfo } from "./HelpData";
import { IconButton, Tooltip } from "@mui/material";

export const HelpTree = {};

HelpTree[AppWord.MENU_CUST_INFO] = {
    key: AppWord.MENU_CUST_INFO,
    tip: '업체정보를 조회하고 관리합니다. 사용자, 담당자 정보 관리, 관제정보 확인, 일시정지, 해지, 되살리기 등의 작업을 합니다.',
    component: HelpCustInfo,
}

/**
 * currentMenuRepo에 있는 값에 따라 도움말 버튼을 보여준다.
 * 아직 도움말이 없으면 null을 리턴한다.
 * @returns {null}
 */
export default function HelpButton() {
    const menuInfo = useReactiveVar(currentMenuRepo);
    // const helpTopic = useReactiveVar(helpTopicRepo);

    const onClickHelp = () => {
        if(menuInfo) {
            switch(menuInfo.menuId) {
                case AppWord.MENU_CUST_INFO:
                    helpTopicRepo(HelpTree[AppWord.MENU_CUST_INFO]);
                    break;
                default:
                    helpTopicRepo({key:null, component: null});
            }
        }
    };

    if(menuInfo && HelpTree[menuInfo.menuId]) {
        if(HelpTree[menuInfo.menuId].tip) {
            return (
                    <Tooltip title={HelpTree[menuInfo.menuId].tip}>
                        <IconButton
                            onClick={onClickHelp}
                            color="inherit"
                        >
                            <InfoIcon />
                        </IconButton>
                    </Tooltip>
            );
        }
        else {
            return(
                    <IconButton
                        onClick={onClickHelp}
                        color="inherit"
                    >
                        <InfoIcon />
                    </IconButton>
            );
        }
    }
    return null;
}

/*


            <Tooltip title={HelpTree[menuInfo.menuId].tip}>
                <IconButton
                    onClick={onClickHelp}
                >
                    <InfoIcon />
                </IconButton>
            </Tooltip>


*/